var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "loading-wrapper"
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("指令方式加载") + "loading",
      hoverable: true,
      bordered: false
    }
  }, [_c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "relative",
    staticStyle: {
      width: "100%",
      height: "150px"
    },
    attrs: {
      "loading-text": _vm.$t("自定义指令") + "loading",
      "loading-spin": "pulse",
      "loading-full": _vm.full
    }
  }, [_c("a-space", {
    attrs: {
      size: 15
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.startCustomLoading(1);
      }
    }
  }, [_vm._v(" v-loading" + _vm._s(_vm.$t("指令全屏")) + " ")]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.startCustomLoading(2);
      }
    }
  }, [_vm._v(" v-loading" + _vm._s(_vm.$t("指令非全屏")) + " ")])], 1)], 1)]), _c("a-card", {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      title: _vm.$t("方法函数加载") + "loading",
      hoverable: true,
      bordered: false
    }
  }, [_c("a-space", {
    attrs: {
      size: 15
    }
  }, _vm._l(_vm.utilList, function (item) {
    return _c("a-button", {
      key: item.type,
      attrs: {
        type: "primary"
      },
      on: {
        click: function ($event) {
          return _vm.startLoading(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.title)) + " ")]);
  }), 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };